module.exports = __webpack_public_path__ + "media/images/svgs/icon-belt-471afced84ffa25d75b51b9c4162a4e7.svg";